import { EntityWithIdAndDescription } from "src/types";

export const OperacionADCMFields = {
    CodOperacionADCM: 'codOperacionADCM',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    UnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    SectorComercial: 'descSectorComercial',
    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',

    // emisor
    RazonSocialEmisor: 'razonSocialEmisor',
    CodEmisorTipo: 'codEmisorTipo',
    DescEmisorTipo: 'descEmisorTipo',
    CodClienteTipo: 'codClienteTipo',
    DescClienteTipo: 'descClienteTipo',
    NroCuenta: 'nroCuenta',
    EmisorPreaprobado: 'emisorPreaprobado',
    RatingCrediticioEmisor: 'ratingCrediticioEmisor',
    Legislacion: 'legislacion',
    InformacionAdicionalEmisor: 'informacionAdicionalEmisor',

    // transaccion
    CodTransaccionTipo: 'codTransaccionTipo',
    DescTransaccionTipo: 'descTransaccionTipo',
    Underwriting: 'underwriting',
    Bridgeloan: 'bridgeloan',
    Monto: 'monto',
    Moneda: 'moneda',
    DestinoFondos: 'destinoFondos',
    CuponTransaccion: 'cuponTransaccion',
    CadenciaPagoCupon: 'cadenciaPagoCupon',
    PlazoVencimiento: 'plazoVencimiento',
    CadenciaAmortizacion: 'cadenciaAmortizacion',
    Fee: 'fee',
    ContratoExclusividad: 'contratoExclusividad',
    Colocadores: 'colocadores',
    Garantias: 'garantias',

    // underwriting
    UnderWritingMonto: 'underWritingMonto',
    UnderWritingFee: 'underWritingFee',
    UnderWritingObservaciones: 'underWritingObservaciones',

    // bridge loan
    BridgeLoanMoneda: 'bridgeLoanMoneda',
    BridgeLoanMonto: 'bridgeLoanMonto',
    BridgeLoanComisionEstructuracion: 'bridgeLoanComisionEstructuracion',
    BridgeLoanTasaInteres: 'bridgeLoanTasaInteres',
    BridgeLoanPlazo: 'bridgeLoanPlazo',
    BridgeLoanTipoAmortizacionCapital: 'bridgeLoanTipoAmortizacionCapital',
    BridgeLoanFrecuenciaPagoInteres: 'bridgeLoanFrecuenciaPagoInteres',
    BridgeLoanGarantias: 'bridgeLoanGarantias',
    BridgeLoanDetalleGarantias: 'bridgeLoanDetalleGarantias',
    BridgeLoanDetalleAforo: 'bridgeLoanDetalleAforo',
    BridgeLoanPrecancelable: 'bridgeLoanPrecancelable',
    BridgeLoanCondicionesPrecancelacion: 'bridgeLoanCondicionesPrecancelacion',
    BridgeLoanEntidadAcreedora: 'bridgeLoanEntidadAcreedora',

    Observaciones: 'observaciones',
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',

    // campos auxiliares para guardar los tipos virtuales de los campos seleccionados
    CodVirtualCliente: 'codVirtualCliente',
    CodVirtualTransaccion: 'codVirtualTransaccion',
    CodVirtualEmisor: 'codVirtualEmisor',
} as const;

export const EntidadCacheFields = {
    CodVirtual: 'codVirtual',
} as const;


